import createClient from '../../apolloClient';
import QUERY_REASSIGN_ESIM_HISTORIES from '../../query/reassignEsimHistories';

const fetchReassignEsimHistories = async (variables) => {
  const apolloClient = createClient();
  const result = await apolloClient.query({
    query: QUERY_REASSIGN_ESIM_HISTORIES,
    variables,
  });
  const { reassignEsimHistories } = result?.data || {};
  if (!reassignEsimHistories?.isSuccess) throw reassignEsimHistories.message;
  return reassignEsimHistories.reassignEsimHistories;
};

export default fetchReassignEsimHistories;
